import Vue from 'vue';
import BespokeCTSMounts from './bespokeCTS.vue';

const urlParams = new URLSearchParams(window.location.search);

new Vue({
  el: '#bespoke',
  render: function (createElement) {
    return createElement(BespokeCTSMounts, {
      props: {
          externalSize: {
              width: urlParams.get('extWidthMM') || 203,
              height: urlParams.get('extHeightMM') || 254
          },
          apertureSize: {
              width: urlParams.get('apWidthMM') || 146,
              height: urlParams.get('apHeightMM') || 197
          },
          displayUnit: urlParams.get('displayUnit') || 'mm'
      }
    })
  }
})